module.exports = __webpack_public_path__ + "0a1f55dcb1ac14f00bd6e31034dacad5.svg";